// import config from '@/utils/config'
// import session from '@/auth/session'

export default [
  { path: '/emitidas/emitidas-como-proveedor', component: () => import('@/views/issued/AsProvider.vue') },
  { path: '/emitidas/emitidas-como-proveedor/:status', component: () => import('@/views/issued/AsProvider.vue') },
  { path: '/emitidas/emitidas-como-pagador', component: () => import('@/views/issued/AsPayer.vue') },
  { path: '/emitidas/emitidas-como-pagador/:status', component: () => import('@/views/issued/AsPayer.vue') },
  /* {
    path: '/emitidas/financiacion',
    beforeEnter() {
      window.open(config.urlEurobitsFinanceables + '/' + config.promoterCode + '/' + session.getToken(), '_blank')
    }
  }, */
  { path: '/emitidas/factoring', component: () => import('@/views/issued/Financeables.vue') },
  { path: '/emitidas/facturas-terceros-por-gastos-suplidos', component: () => import('@/views/issued/ThirdPartyInvoices.vue') }
]
